import svgUrl from "ni:svgr;oMOEhr10rjjHy0AsIa8DEZ229H_UBmLhaMVTM4EloXg";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const EnrichmentZoomInfoLIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}><rect x={2} y={2} width={28} height={28} rx={4} fill="var(--tbl--ui-node-icon--enrichment--zoom-info-secondary)" /><path fillRule="evenodd" clipRule="evenodd" d="M9 9H9.5H18V10H10V12.5H9V9.5V9ZM21.2929 10H20V9H22.5H23V9.5V12H22V10.7071L10.7071 22H13V23H9.5L9.14645 22.1464L21.2929 10ZM22.5 19V22.5V23H22H15V22H21.5V19H22.5Z" fill="var(--tbl--ui-node-icon--enrichment--zoom-info-primary)" /></svg>;
const Memo = memo(EnrichmentZoomInfoLIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "EnrichmentZoomInfoLIcon";
}